/**
 * The accent scopes declared by `css/accent.css`: one Neutral collection plus
 * seven accents, each re-pointing the same semantic colour utilities for its
 * subtree.
 */
export const ACCENTS = ["blue", "green", "neutral", "orange", "pink", "purple", "red", "yellow"] as const;

export type Accent = (typeof ACCENTS)[number];

const isAccent = (value: unknown): value is Accent => ACCENTS.includes(value as Accent);

/** Props opening an accented subtree; spread onto the element that owns it.
 *  An unrecognised accent yields no attribute at all rather than a scope with
 *  no rungs behind it, so the subtree keeps the scope it inherits. */
export function accentScope(accent: Accent | null | undefined): { "data-accent"?: Accent } {
  return isAccent(accent) ? { "data-accent": accent } : {};
}
